export const formatDate = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toISOString().split("T")[0];
};

// Format a date string as M/D/YYYY (US style)
export const formatDateUS = (dateString) => {
  if (!dateString) return "";
  const d = new Date(dateString);
  const m = d.getMonth() + 1;
  const day = d.getDate();
  const y = d.getFullYear();
  return `${m}/${day}/${y}`;
};

export const formatRelativeTime = (dateString) => {
  if (!dateString) return "";

  const now = new Date();
  const messageDate = new Date(dateString);
  const diffInMs = now - messageDate;
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  // If less than 1 minute
  if (diffInMinutes < 1) {
    return "Just now";
  }

  // If less than 1 hour
  if (diffInMinutes < 60) {
    return `${diffInMinutes} min ago`;
  }

  // If less than 24 hours
  if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
  }

  // If more than 24 hours, show date
  if (diffInDays < 7) {
    return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
  }

  // If more than a week, show actual date
  return messageDate.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year:
      messageDate.getFullYear() !== now.getFullYear() ? "numeric" : undefined,
  });
};
